import { useEffect, useState } from "react";
import { type AdminKycVerification, ApiError, api } from "../api/client.js";
import { asMoment } from "../format.js";

export function KycReview({ playerId }: { playerId: string }) {
  const [verification, setVerification] = useState<AdminKycVerification | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    api
      .playerKyc(playerId, controller.signal)
      .then(({ verification: result }) => setVerification(result))
      .catch((caught: unknown) => {
        if (!controller.signal.aborted)
          setError(caught instanceof ApiError ? caught.message : "Could not load KYC status.");
      });
    return () => controller.abort();
  }, [playerId]);

  if (error) return <p className="banner">{error}</p>;
  if (!verification) return <p className="dim">Loading KYC status…</p>;

  return (
    <>
      <div className="card-bar">
        <span className="label-14-strong">Sumsub verification</span>
        <span className={`badge badge-${verification.status}`}>{verification.status}</span>
      </div>
      <div className="facts">
        <div className="fact">
          <div className="fact-label">Applicant ID</div>
          <div className="fact-value mono-12">{verification.applicantId ?? "Not created"}</div>
        </div>
        <div className="fact">
          <div className="fact-label">Level</div>
          <div className="fact-value">{verification.levelName ?? "—"}</div>
        </div>
        <div className="fact">
          <div className="fact-label">Decision</div>
          <div className="fact-value">{verification.reviewAnswer ?? "—"}</div>
        </div>
        <div className="fact">
          <div className="fact-label">Reject type</div>
          <div className="fact-value">{verification.reviewRejectType ?? "—"}</div>
        </div>
        <div className="fact">
          <div className="fact-label">Last provider event</div>
          <div className="fact-value">
            {verification.lastEventAt ? asMoment(verification.lastEventAt) : "—"}
          </div>
        </div>
        <div className="fact">
          <div className="fact-label">Reviewed</div>
          <div className="fact-value">
            {verification.reviewedAt ? asMoment(verification.reviewedAt) : "—"}
          </div>
        </div>
      </div>
      {verification.rejectLabels.length > 0 ? (
        <div className="card-bar">
          <div>
            <div className="label-14-strong">Rejection labels</div>
            <div className="label-13 faint">{verification.rejectLabels.join(", ")}</div>
          </div>
        </div>
      ) : null}
    </>
  );
}
